
import { makeStateKey } from '@angular/core';

export const STATE_KEY_SSR_REDIRECT = makeStateKey<string>('STATE_KEY_SSR_REDIRECT');
